module.exports = __webpack_public_path__ + "c44a6de7e392b878d07dbd576ffcc3f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/contactus/phone.svg
// module id = 1097
// module chunks = 0